import { Ref, Button, Text } from "@tblabs/truffle";
import { Box } from "./Box";


export class SimpleQuantityBox extends Box
{
    constructor(quantity: Ref<number>, dataTestId?: string)
    {
        super("quantity-control",[
                new Button("-", () => { if (quantity.value > 1) quantity.value--; }).Class("quantity-control__button")
                    .Attribute("data-testid", dataTestId + "-decrement"),
                new Text(quantity).Class("quantity-control__value--number").Attribute("data-testid", dataTestId + "-value"),
                new Button("+", () => quantity.value++).Class("quantity-control__button")
                    .Attribute("data-testid", dataTestId + "-increment"),

                // TODO: Add discount info
        ]);
    }
}
